import React from 'react';
import { Modal, Button, List } from 'antd';
import { useTranslation } from '../../../i18n/useTranslation';

interface ReadOnlyWarningModalProps {
    visible: boolean;
    onClose: () => void;
    readOnlyItems: string[];
    entityType?: string;
    title?: string;
    message?: string;
}

/**
 * Modal component for warning about read-only items that cannot be deleted.
 * Displays a list of read-only items and informs the user that they cannot be deleted.
 */
function ReadOnlyWarningModal({
    visible,
    onClose,
    readOnlyItems,
    entityType = 'Datasets',
    title,
    message,
}: ReadOnlyWarningModalProps) {
    const { t } = useTranslation();

    const modalTitle = title || t('Cannot Delete {{name}}', { name: t(entityType) });
    const modalMessage = message || t('This asset is marked as read-only and cannot be deleted.');

    return (
        <Modal
            centered
            closable={false}
            visible={visible}
            onCancel={onClose}
            className="f-dialog"
            footer={
                <Button type="default" onClick={onClose}>
                    {t('Close')}
                </Button>
            }
        >
            <h1 className="f-dialog-title">{modalTitle}</h1>
            <p className="f-dialog-text">{modalMessage}</p>
            {readOnlyItems.length > 0 && (
                <div className="mt-3">
                    <p className="mb-3" style={{ fontWeight: 500 }}>
                        {t('Read Only')} {t(entityType)}:
                    </p>
                    <List
                        size="small"
                        bordered
                        dataSource={readOnlyItems}
                        renderItem={(name) => <List.Item>{name}</List.Item>}
                        style={{ maxHeight: 200, overflowY: 'auto' }}
                    />
                </div>
            )}
        </Modal>
    );
}

export default ReadOnlyWarningModal;
